import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DatePicker from "react-datepicker";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Label,
  Button,
} from "reactstrap";
import { DataTable, TableRowField, ExportCSV } from "../../../../components";
import { getDailyBalance } from "../../../../store/report/actions";
import { messages, layout, roles } from "../../../../common/constants";
import MediaQuery from "react-responsive";
import { selectDailyBalanceColumns } from "../../../../store/report/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { formatHelper } from "../../../../common/helpers";
import { getDailyBalance as dailyBalanceExport } from "../../../../service/report";
import Select from "react-select";
import moment from "moment";
import { getUsers } from "../../../../store/user/actions";
import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { exportExcel } from "./excel";

class DailyBalance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      selectedDate: null,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainReportExport = this.handleObtainReportExport.bind(this);

    this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });
    this.performGetDailyBalance();
  }

  async componentDidMount() {
    await this.setState({ selectedDate: moment() });
    await this.props.getStores({ reset: true });
    await this.performGetDailyBalance(true);
  }

  performGetDailyBalance(reset = false) {
    const { getDailyBalance } = this.props;
    const { page, selectedDate } = this.state;
    const store = this.state.selectedStore.value;
    if (!selectedDate) return;
    getDailyBalance({ page, store, reset, selectedDate: selectedDate._d });
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetDailyBalance();
  }

  async handleDateChange(selectedDate) {
    await this.setState({
      selectedDate: selectedDate,
    });
    this.performGetDailyBalance();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  renderDataTable(columns) {
    return (
      <DataTable
        data={this.props.dailyBalance}
        keyField="id"
        columns={columns}
        page={this.state.page}
        totalSize={this.props.total}
        sizePerPage={this.props.pageSize}
        loading={this.props.loading}
        onPageChange={this.handlePageChange}
      />
    );
  }

  handleObtainReportExport() {
    this.setState({ loadingExport: true });
    const { selectedDate, selectedStore } = this.state;
    const { totalCashPayed, totalCardPayed } = this.props;
    // moment(new Date)._d
    dailyBalanceExport(0, selectedStore.value, selectedDate._d)
      .then((response) => {
        exportExcel(
          response.data.data,
          selectedStore,
          selectedDate,
          totalCashPayed,
          totalCardPayed
        );
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }
  handleExportCSV() {
    const { selectedDate } = this.state;
    const { totalCashPayed, totalCardPayed } = this.props;
    var csvRow = [];
    var A = [
      [
        "",
        "Código de venta",
        "Sede",
        "Hora",
        "Cliente",
        "Concepto",
        "Método de pago",
        "Total Recaudado",
      ],
    ];
    var re = this.state.dailyBalanceExport.filter((x) => x.deleted_at == null);
    var storeName = this.state.selectedStore.label;

    var totalIncome = 0;

    for (var item = 0; item < re.length; item++) {
      var itemConceptArray = [];
      var itemTotalPrice = re[item].total_net;
      var itemConcept = "";

      re[item].Sell_details.forEach((element) => {
        if (element.Service) {
          itemConceptArray.push(element.quantity + " " + element.Service.name);
        } else if (element.Product) {
          itemConceptArray.push(element.quantity + " " + element.Product.name);
        } else if (element.Offer) {
          itemConceptArray.push(element.quantity + " " + element.Offer.name);
        }
      });
      itemConcept = itemConceptArray.join("/");

      A.push([
        item + 1,
        re[item].receipt_id,
        re[item].Store.name,
        re[item].created_at_hour,
        re[item].Customer.name + " " + re[item].Customer.lastname,
        itemConcept,
        re[item].Sell_payment_type.name,
        itemTotalPrice,
      ]);
      totalIncome += itemTotalPrice;
    }

    A.push(["", "", "", "", "Total", totalIncome]);
    A.push([
      "",
      "",
      "En Efectivo",
      totalCashPayed,
      "Con tarjeta",
      totalCardPayed,
    ]);

    for (var item = 0; item < A.length; item++) {
      A[item][1] = String(A[item][1]).replace(/\s/g, " ");
      A[item][2] = String(A[item][2]).replace(/\s/g, " ");
      A[item][3] = String(A[item][3]).replace(/\s/g, " ");
      csvRow.push(A[item].join(","));
    }

    var csvString = csvRow.join("\r\n");
    storeName = String(storeName).replace(/\s/g, "_");

    var a = document.createElement("a");
    a.href =
      "data:attachment/csv;charset=utf-16le,%EF%BB%BF" + encodeURI(csvString);
    a.target = "_Blank";
    a.download =
      this.state.selectedStore.value == 0
        ? formatHelper.toDateYYMMDD(selectedDate) +
          "_reporte-general-balance-diario.csv"
        : formatHelper.toDateYYMMDD(selectedDate) +
          "_reporte-balance-diario_" +
          storeName.toLowerCase() +
          ".csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  optionsFormatterColumn(cell, row) {
    return (
      <Button
        type="button"
        color="primary"
        size="sm"
        onClick={() =>
          this.props.history.push(`/report/dailybalance/${row.id}/detail`)
        }
      >
        <i className="fa fa-eye"></i>
      </Button>
    );
  }

  render() {
    const columnOption = {
      dataField: "",
      text: "",
      formatter: this.optionsFormatterColumn,
      style: { width: "50px" },
      headerStyle: { width: "50px" },
    };

    const columnsXS = [
      {
        dataField: "xs",
        text: "Balance Diario",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField
                label="Código de Venta:"
                value={row.receipt_id_store}
              />
              <TableRowField label="Cliente:" value={row.customer} />
              <TableRowField label="Concepto:" value={row.sellDetail} />
              <TableRowField label="Forma Pago:" value={row.paymentMethod} />
              <TableRowField label="Total (S/):" value={row.total} />
            </div>
          );
        },
      },
      columnOption,
    ];
    const columnsSM = [
      {
        dataField: "xs",
        text: "Balance Diario",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField
                label="Código de Venta:"
                value={row.receipt_id_store}
              />
              <TableRowField label="Cliente:" value={row.customer} />
              <TableRowField label="Concepto:" value={row.sellDetail} />
            </div>
          );
        },
      },
      {
        dataField: "paymentMethod",
        text: "Forma Pago",
        style: { width: "180px" },
        headerStyle: { width: "180px" },
      },
      {
        dataField: "total",
        text: "Total (S/)",
        style: { width: "180px" },
        headerStyle: { width: "180px" },
      },
      columnOption,
    ];
    const columnsMD = [
      {
        dataField: "xs",
        text: "Código de Venta",
        formatter: (cell, row) => {
          return (
            <div>
              <TableRowField label="" value={row.receipt_id_store} />
            </div>
          );
        },
      },
      {
        dataField: "created_at_hour",
        text: "Hora",
      },
      {
        dataField: "customer",
        text: "Cliente",
      },
      {
        dataField: "sellDetail",
        text: "Concepto",
      },
      {
        dataField: "paymentMethod",
        text: "Forma Pago",
      },
      {
        dataField: "total",
        text: "Total (S/)",
      },
      {
        dataField: "type",
        text: "Tipo",
      },
      columnOption,
    ];

    const { selectedDate } = this.state;
    const className = "form-control";
    return (
      <div>
        <Card>
          <CardHeader>
            <i className="icon-chart"></i>Balance Diario
          </CardHeader>
          <CardBody>
            <div>
              <div>
                <hr className="my-4" />
                {(this.props.role == roles.SUPER_ADMIN ||
                  this.props.role == roles.ADMIN) && (
                  <Row className="my-4">
                    <Col sm="1">
                      <Label className="mt-2">Tienda:</Label>
                    </Col>
                    <Col sm="4">
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isLoading={this.props.loadingStores}
                        isSearchable={true}
                        noOptionsMessage={() => {
                          return messages.SELECT_NO_OPTIONS;
                        }}
                        placeholder=""
                        options={this.props.stores}
                        loadingMessage={() => {
                          return messages.SELECT_LOADING;
                        }}
                        onChange={this.handleStoreChange}
                        value={this.state.selectedStore}
                        isDisabled={
                          this.props.loadingStores || this.props.loading
                        }
                      />
                    </Col>
                  </Row>
                )}
                <Row className="mb-2">
                  <Col sm="1">
                    <Label className="mt-2">Fecha:</Label>
                  </Col>
                  <Col sm="4">
                    <DatePicker
                      selected={
                        selectedDate != null
                          ? moment(selectedDate, "DD-MM-YYYY")
                          : null
                      }
                      disabled={this.props.loading || this.props.loadingStores}
                      onChange={(selectedDate) =>
                        this.handleDateChange(selectedDate)
                      }
                      className={className}
                      dateFormat={"DD/MM/YYYY"}
                      showYearDropdown
                      showMonthDropdown
                      minimumNights={0}
                    />
                  </Col>
                </Row>

                <hr className="my-4" />
              </div>

              <Row className="sm-2">
                <Col sm="3" lg="3">
                  <b>Total del Dia (S/):</b>{" "}
                  {formatHelper.toMoney(this.props.totalBought)}
                </Col>
                <Col sm="3" lg="3">
                  <b>Total Notas de Crédito (S/): </b>{" "}
                  {formatHelper.toMoney(this.props.totalCreditNotes)}
                </Col>
                <Col sm="6" lg="6">
                  <ExportCSV
                    disabled={this.state.loadingExport}
                    exportCSV={this.handleObtainReportExport}
                    minWidth={420}
                  />
                </Col>
              </Row>

              <Row className="sm-2">
                <Col sm="3" lg="3">
                  <b>Con efectivo (S/):</b>{" "}
                  {formatHelper.toMoney(this.props.totalCashPayed)}
                </Col>
                <Col sm="3" lg="3">
                  <b>Con tarjeta (S/): </b>{" "}
                  {formatHelper.toMoney(this.props.totalCardPayed)}
                </Col>
                <Col sm="6" lg="6"></Col>
              </Row>
              <hr className="my-4" />
            </div>
            <Row>
              <Col>
                <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                  {this.renderDataTable(columnsXS)}
                </MediaQuery>
                <MediaQuery
                  minWidth={layout.SM_MIN_WIDTH}
                  maxWidth={layout.MD_MAX_WIDTH}
                >
                  {this.renderDataTable(columnsSM)}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                  {this.renderDataTable(columnsMD)}
                </MediaQuery>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    totalBought,
    totalCreditNotes,
    total,
    pageSize,
    error,
    loading,
    totalCashPayed,
    totalCardPayed,
  } = state.report.dailyBalanceList;

  return {
    dailyBalance: selectDailyBalanceColumns(state),
    stores: selectStoresForSelect(state),
    totalBought,
    totalCreditNotes,
    totalCashPayed,
    totalCardPayed,
    total,
    pageSize,
    error,
    role: selectUserRole(state),
    loading,
    loadingStores: state.store.storeList.loading,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDailyBalance,
      getUsers,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DailyBalance);



// WEBPACK FOOTER //
// ./src/scenes/Report/Cash/DailyBalance/DailyBalance.js